import React from 'react';
import { useIntl } from 'react-intl';
import { passwordRegex } from '../../../helpers/regex';
import { Input } from '../Input/Input';

interface IPasswordInputProps {
    name: string;
    value?: string;
    disabled?: boolean;
    required?: boolean;
    placeholder?: string;
    className?: string;
    touched?: boolean;
    repeatValue?: string;
    autoComplete?: string;
    errorMessage?: string;
    passwordRegex?: RegExp;
    onChange?: (event: React.FormEvent, isValid: boolean) => void;
    errorHandler?: (value: string) => string;
    checkShownErrors?: (name: string, errorMessage: string) => void;
}

export const PasswordInput = (props: IPasswordInputProps): JSX.Element => {
    const { formatMessage } = useIntl();

    const errorHandler = (value: string): string => {
        if (value && value.match(props.passwordRegex || passwordRegex) === null) {
            return formatMessage({ id: props.errorMessage || 'INVALID_PASSWORD' });
        } else if (props.repeatValue !== undefined && value !== props.repeatValue) {
            return formatMessage({ id: 'PASSWORD_MISMATCH' });
        } else if (props.errorHandler) {
            return props.errorHandler(value);
        }
        return '';
    };

    return <Input {...props} type="password" errorHandler={errorHandler} externalUpdateValue={props.repeatValue} />;
};
